import { ChevronRight, Code, CreditCard, Megaphone, Users } from "lucide-react"
import { leadInterceptionContent } from "./leadInterceptionContent"

const itemIcons = [Users, Code, Megaphone, CreditCard]

const cardClass =
  "rounded-[2px] border border-solid border-[#E6E6E6] transition-colors hover:border-[#8F8F8F]"

export default function LeadInterceptionSection() {
  return (
    <section className="w-full translate-x-[calc(50vw-50%-1.5rem)]">
      <div className="grid w-full grid-cols-1 items-stretch gap-6 lg:grid-cols-2">
        <div className={`flex h-full flex-col justify-between gap-8 p-8 ${cardClass}`}>
          <h2 className="text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8">
            {leadInterceptionContent.title}
          </h2>
          <p className="text-pretty text-[16px] font-normal leading-6 text-[#4D4D4D]">
            {leadInterceptionContent.body}
          </p>
        </div>
        <ul className="m-0 flex list-none flex-col gap-3 p-0">
          {leadInterceptionContent.items.map((item, index) => {
            const Icon = itemIcons[index]
            return (
              <li
                key={item}
                className={`flex items-center gap-3 p-6 text-[14px] font-medium leading-5 text-[#171717] ${cardClass}`}
              >
                <Icon className="size-4 shrink-0" strokeWidth={1.5} aria-hidden="true" />
                <span>
                  <span className="font-bold">Without</span>
                  {item.slice("Without".length)}
                </span>
                <ChevronRight className="size-3 shrink-0" strokeWidth={1.5} aria-hidden="true" />
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
